import { currentLang } from '../utils/getLanguage';
import { $Q } from '../utils/querySelector';

export const registerLanguageTag = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const registerContainer = $Q('.customer.register');

    const updateLanguageTag = () => {
      $Q(
        '#customer_language_tag'
      ).value = `language_${currentLang}`;
    };

    if (registerContainer) {
      document.addEventListener('DOMContentLoaded', () => {
        updateLanguageTag();
      });
    }
  });
};
